import { Injectable } from '@angular/core';
import {HttpService, QueryModel} from '../http/http.service';
import {catchError, map, Observable} from 'rxjs';
import {iResponse} from '../../models/response/response.model';
import {CawawiArticlePagingModel} from '../../models/cawawi/cawawi.article';
import {CawawiArticleQueryModel, FilterArticleQuery} from '../../models/cawawi/cawawi-article-query.model';

@Injectable({
  providedIn: 'root'
})
export class CawawiService extends HttpService{

    // Article Query: perPage: number, pageNumber: number, sortOrder ( 'ASC' | 'DESC' ), orderBy: string, searchText: string
    getCawawiArticles(query: QueryModel): Observable<iResponse<CawawiArticlePagingModel>> {
        return this.get('cawawi/articles', query).pipe(
            map((response: iResponse<CawawiArticlePagingModel>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }

    // New Article List API
    postGetCawawiArticle(query: FilterArticleQuery): Observable<any> {
        return this.post('cawawi/articles', query).pipe(
            map((response: iResponse<CawawiArticlePagingModel>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }
}
